import _remove from 'lodash/remove';
import head from 'lodash/head';
import set from 'lodash/set';
import addStudentsTemplate from './../add-students/add-students.html';
import manageStudentDialogTemplate from '../../../components/manage-student/manage-student-dialog.html';
import template from './step-3.html';

class StepThirdComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    GroupService,
    SchoolClassService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.GroupService = GroupService;
    this.SchoolClassService = SchoolClassService;
    this.schoolClasses = [];
    this.selectedAssignIDs = [];
    this.students = [];
  }

  $onInit() {
    this.SchoolClassService.getSchoolClass().then(result => {
      this.schoolClasses = result;
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać oddziałów')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
    this.GroupService.getAllGroups(true).then(result => {
      this.groups = result;
    });
  }

  $onChanges(changes) {
    if (changes.groups) {
      this.groups = Object.assign([], this.groups);
      _remove(this.groups, group => group.default);
    }

    if (changes.me) {
      this.me = {...this.me};
    }
  }

  setFilter(form) {
    if (form.$invalid) {
      return false;
    }

    this.loadStudents();
  }

  loadStudents(groupId = 0, fromServer = true) {
    let id = groupId;
    if (id <= 0) {
      id = this.selectedGroupId;
    }

    this.GroupService.getStudents(id, fromServer).then(result => {
      this.students = result;
      if (this.students.length === 0) {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Pusta grupa. Dodaj uczniów do grupy.')
            .position('bottom right')
            .hideDelay(3000)
        );
      }
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać uczniów z grupy')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  assignStudents(ev) {
    if (this.groups.length === 0) {
      this.$mdDialog.show(
        this.$mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Brak grup świetlicowych')
          .textContent('Przed dodaniem uczniów do grupy, dodaj przynajmniej jedną grupę.')
          .ariaLabel('Przed dodaniem uczniów do grupy, dodaj przynajmniej jedną grupę.')
          .ok('Zamknij')
          .targetEvent(ev)
      );
      return false;
    }

    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddStudentsController',
      locals: {schoolClasses: this.schoolClasses, groups: this.groups},
      template: addStudentsTemplate,
      disableParentScroll: true,
      clickOutsideToClose: true,
      targetEvent: ev
    }).then(groupId => {
      this.selectedGroupId = groupId;
      this.loadStudents(groupId, true);
    });
  }

  unassignStudentsFromGroup(ids, ev) {
    ev.stopPropagation();
    this.GroupService.deleteFromGroup(this.selectedGroupId, ids).then(() => {
      this.selectedAssignedIDs = [];
      if (this.selectedGroupId) {
        this.loadStudents(0, true);
      }

      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Usunięto uczniów z grupy')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  /*
   * Selected row callback - function trigger after row selected
   * @param rowsIds {Array}
   */

  selectedAssignRowCallback(rowsIds) {
    this.selectedAssignedIDs = rowsIds;
  }

  unassignSelected(ev) {
    if (angular.isDefined(this.selectedAssignedIDs) && this.selectedAssignedIDs.length > 0) {
      this.unassignStudentsFromGroup(this.selectedAssignedIDs, ev);
    } else {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Zaznacz uczniów do usunięcia')
          .position('bottom right')
          .hideDelay(3000)
      );
    }
  }

  getStudentById(id) {
    return head(
      this.students.filter(student => student.id === id)
    );
  }

  manageStudent(studentId, event) {
    event.stopPropagation();
    const student = this.getStudentById(studentId);
    this.$mdDialog.show({
      bindToController: true,
      controller: 'ManageStudentDialogController',
      controllerAs: 'ctrl',
      template: manageStudentDialogTemplate,
      disableParentScroll: true,
      targetEvent: event,
      locals: {
        student,
        successCallback: ({isPermittedToLeaveOnOwn}) => set(student, 'isPermittedToLeaveOnOwn', isPermittedToLeaveOnOwn),
        errorCallback: () => {}
      }
    });
  }
}

export const StepThird = {
  bindings: {
    me: '<'
  },
  template,
  controller: StepThirdComponent
};
